
import { LoggingMessage, LoggingSearch, LoggingService } from "@nt-portal/server-sdk";
import { BaseClientService } from "../base-client.service";
import { ControllerOptions, DataController } from "../../../types";


export interface LoggingOptions extends ControllerOptions<LoggingMessage> {
    filter?: LoggingSearch
}


export class ClientLoggingService extends BaseClientService implements DataController<LoggingMessage> {

    private _service: LoggingService;


    constructor() {
        super();
        this._service = new LoggingService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async get(options: LoggingOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }


    public async getById(options: LoggingOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: LoggingOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }
    

    public async delete(options: LoggingOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }
}


